export default __webpack_public_path__ + "static/media/celebration.1f836afc.png";